module.exports = __webpack_public_path__ + "img/home.8ab333da.svg";